import { Navigate, Outlet, useOutletContext } from "react-router-dom";
// import SimpleLoader from "../../Loader/SimpleLoader";
import SmashLoader from "../../Loader/SmashLoader";

export default function ProtectedRoute({
  isAllowed,
  isLoading,
  redirectPath = "/login",
  children,
}) {
  const parentOutletContext = useOutletContext();

  if (isLoading) {
    return <SmashLoader />;
  }

  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet context={parentOutletContext} />;
}
